import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Favourite } from '@shared/models/favourite';

export const favouriteAdapter: EntityAdapter<Favourite> = createEntityAdapter<Favourite>({
  selectId: (favourite) => `${favourite.id}-${favourite.type}`,
});
